export default "__VITE_ASSET__BiaWU2XG__"